import React, { type CSSProperties } from 'react';
import { Icon, Typography } from '@packages/ui/shared';
import { SkeletonLoader } from '@web/components/skeleton-loader';
import type { TextStyle } from 'react-native';

interface CaseManagementCardHeaderProps {
    iconName: string;
    title: string;
    iconColor?: keyof typeof import('@packages/core/styles/colors').default;
    count?: number;
    className?: string;
    isLoading?: boolean;
}

const containerStyle: CSSProperties = {
    display: 'flex',
    height: 56,
    padding: '16px 20px',
    alignItems: 'center',
    gap: 10,
    alignSelf: 'stretch',
    border: '1px solid #E3E3E3',
    background: '#F8F8F8',
};

const titleStyle: TextStyle = {
    lineHeight: 24,
};

export function CaseManagementCardHeader({
    iconName,
    title,
    count = 0,
    className,
    iconColor = 'blueOne',
    isLoading = false,
}: CaseManagementCardHeaderProps) {
    return (
        <div className={className} style={containerStyle}>
            {isLoading ? (
                <>
                    <SkeletonLoader type="icon" width={26} height={26} />
                    <SkeletonLoader type="text" width="70%" height={20} className="mt-2" />
                </>
            ) : (
                <>
                    <Icon name={iconName} color={iconColor} size={26} />
                    <Typography variant="h4" style={titleStyle}>{`${title} (${count})`}</Typography>
                </>
            )}
        </div>
    );
}
